import { render, staticRenderFns } from "./StaticStatisticsSetting.vue?vue&type=template&id=7831614b&scoped=true&"
import script from "./StaticStatisticsSetting.vue?vue&type=script&lang=js&"
export * from "./StaticStatisticsSetting.vue?vue&type=script&lang=js&"
import style0 from "./StaticStatisticsSetting.vue?vue&type=style&index=0&id=7831614b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7831614b",
  null
  
)

export default component.exports